import { IconBox, ClickIcon } from "@hightouch/htui";
import { SchemaIconProps } from "./types";

/**
 * @important
 * Always ensure svg within the wrapper is set to 100% size and has no width/height props so that it fits to the wrapper.
 */
export const EventIcon = ({ size = "xl", ...props }: SchemaIconProps) => {
  return <IconBox color="teal" icon={<ClickIcon />} size={size} {...props} />;
};
